// ©2024 Austin App House. All rights reserved.
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import FilePreviewElement from '../../../../FilePreviewElement';

const UploadDocumentsField = ({
  input: { value, onChange },
  toggleModal,
  documentVisibility,
  formName,
  change
}) => {
  const [imgSrc, setImgSrc] = useState([]);

  useEffect(() => {
    for (let i = 0; i < value.length; i++) {
      const element = value[i];
      createFileObj(element);
    }
  }, [value]);

  const createFileObj = useCallback((file) => {
    
    if (typeof file === 'string') {
      setImgSrc((prev) => [...new Set([...prev, file])]);
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);

    const imageNameSplittedArray = file.name.split('.');
    const fileType = (
      ['png', 'jpg', 'jpeg', 'bmp'].includes(imageNameSplittedArray[imageNameSplittedArray.length - 1])
    ) ? 'image' : 'file';
    reader.onloadend = () => {
      setImgSrc(prev => [...prev, {
        type: fileType,
        file: reader.result,
        name: file.name,
      }]);
    };

    
  }, [value, imgSrc])

  const handleFileUpload = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      toggleModal(
        true,
        'confirmModal',
        true,
        {
          onAccept: () => {
            onChange([...value, ...files]);
            const visibilitiItems = {}
            Object.values(files).forEach((f) => {
              visibilitiItems[encodeURIComponent(`${f.name}`).replace(/\./g, '%2E')] = true
            })
            change(formName, 'documentVisibility', {...documentVisibility, ...visibilitiItems});
          },
          header: 'Make this document viewable to the contractor prior to assignment?',
          buttonLabels: { reject: 'No' },
          onReject: () => {
            onChange([...value, ...files]);
            const visibilitiItems = {}
            Object.values(files).forEach((f) => {
              visibilitiItems[encodeURIComponent(`${f.name}`).replace(/\./g, '%2E')] = false
            })
            change(formName, 'documentVisibility', {...documentVisibility, ...visibilitiItems});
          }
        },
      );
     
    }
  };

  const removeImage = (index) => {
    setImgSrc(prev => prev.filter((el, i) => i !== index));
    onChange(value.filter((el, i) => i !== index));
  };

  return (
    <div className="fields_group">
      <div className="add_btns">
        <label className="standard_btn icon_upload" style={{ position: 'relative', overflow: 'hidden' }}>
          <input
            type="file"
            multiple
            onChange={handleFileUpload}
            style={{ position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer' }}
            aria-label="upload documents"
          />
         Click here to add file
        </label>
      </div>
      {!!imgSrc.length && (
        <div className="uploaded_files_list">
          {
            imgSrc.map((data, i) => (
              <FilePreviewElement
                /* eslint-disable-next-line react/no-array-index-key */
                key={(data?.name || data) + i}
                fileInfo={data}
                data={data}
                index={i}
                removeImage={removeImage}
                toggleModal={toggleModal}
              />
            ))
          }
        </div>
      )}
    </div>
  );
};

export default UploadDocumentsField;
